import { render, staticRenderFns } from "./cust-detail.vue?vue&type=template&id=631cdf8e&scoped=true"
import script from "./cust-detail.vue?vue&type=script&lang=js"
export * from "./cust-detail.vue?vue&type=script&lang=js"
import style0 from "./cust-detail.vue?vue&type=style&index=0&id=631cdf8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "631cdf8e",
  null
  
)

export default component.exports